"use strict";

//========== remove trasitions ==============
document.addEventListener("DOMContentLoaded", function () {
  let node = document.querySelector(".o-preload-transitions");
  node.classList.remove("o-preload-transitions");
});

//========== fade in ==============
const scrollElements = document.querySelectorAll(".is-to-fade");
const elementInView = (el, offset = 1) => {
  const elementTop = el.getBoundingClientRect().top;
  return (
    elementTop <=
    (window.innerHeight || document.documentElement.clientHeight) / offset
  );
};
const elementOutofView = (el) => {
  const elementTop = el.getBoundingClientRect().top;
  return (
    elementTop > (window.innerHeight || document.documentElement.clientHeight)
  );
};
const displayScrollElement = (element) => {
  element.classList.add("has-scrolled");
};
const hideScrollElement = (element) => {
  element.classList.remove("has-scrolled");
};
const handleScrollAnimation = () => {
  scrollElements.forEach((el) => {
    if (elementInView(el, 1)) {
      displayScrollElement(el);
    } else if (elementOutofView(el)) {
      hideScrollElement(el);
    }
  });
};
handleScrollAnimation();

//========== Has scrolled ==============
const hasScrolled = () => {
  const nav = document.querySelector(".c-header");
  if (
    document.body.scrollTop >= 50 ||
    document.documentElement.scrollTop >= 50
  ) {
    nav.classList.add("has-scrolled-header");
  } else {
    nav.classList.remove("has-scrolled-header");
  }
};
hasScrolled();

//========== Window scroll==============
window.addEventListener("scroll", () => {
  throttle(handleScrollAnimation, hasScrolled, 250);
});

//========== Scroll Throttle timer==============
let throttleTimer = false;
const throttle = (callbackAnimate, callbackScrolled, time) => {
  if (throttleTimer) return;
  throttleTimer = true;
  setTimeout(() => {
    callbackAnimate();
    callbackScrolled();
    throttleTimer = false;
  }, time);
};

//========== Scroll Throttle timer ==============
const mobileNav = document.querySelector(".c-burger__btn");
const mobileMenu = document.querySelector(".c-nav");

mobileNav.addEventListener("click", function () {
  mobileNav.classList.toggle("is-active");
  mobileMenu.classList.toggle("is-active");
});

//========== Submenu ==============

const subMenu = document.querySelectorAll(".menu-item-has-children > a");
const addAria = () => {
  subMenu.forEach((e) => {
    e.setAttribute("aria-haspopup", "true");
    e.setAttribute("aria-expanded", "false");
  });
};
addAria();

const toggleMenu = (e) => {
  e.preventDefault();
  if (e.currentTarget.classList.contains("is-open")) {
    e.currentTarget.classList.remove("is-open");
    e.currentTarget.setAttribute("aria-expanded", "false");
  } else {
    subMenu.forEach((e) => {
      e.classList.remove("is-open");
      e.setAttribute("aria-expanded", "false");
    });
    e.currentTarget.classList.add("is-open");
    e.currentTarget.setAttribute("aria-expanded", "true");
  }
};

subMenu.forEach((e) => {
  e.addEventListener("click", toggleMenu);
});

//========== Hero animations ==============
const heroText = document.querySelectorAll(".c-hero__fade");

const heroAnimate = () => {
  heroText.forEach((e) => {
    e.classList.add("is-ready");
  });
};
heroAnimate();

document.addEventListener("DOMContentLoaded", function () {
  heroAnimate();
});
